var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spWithdrawal"},[_c('sPWithdrawal',{attrs:{"hostroletype":_vm.hostroletype,"hostroleinnerid":_vm.hostroleinnerid}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }